import { store } from '../packs/index';
import { logEvent } from '../helpers/analytics';
import { trackEvent } from '../actions/trackEventActions';
export const newWindow = (path, source = null) => {
  window.open(path, '_blank');
  store.dispatch(trackEvent('CLICKED_OTHER_EXTERNAL_LINK', { url: path }));
  logEvent('ExternalLinkClicked', {
    href: path,
    source: source,
  });
};
